/* eslint-disable global-require,no-underscore-dangle */

const ENV_APP_SETTINGS = {
  PRODUCTION: {
    CLIENT_ID: '2f5c4a5f8b5db8a2a85109645ca8fafcfddd7975ef12d615c99d94ea7efce7df',
    VERSION: '6'
  },
  STAGING: {
    CLIENT_ID: '1b374ffc7d08132517da3c3cf635889cf172ca2da6db3e8a01c87fa349fe88bf',
    VERSION: '6'
  },
  DEVELOPMENT: {
    CLIENT_ID: '1b374ffc7d08132517da3c3cf635889cf172ca2da6db3e8a01c87fa349fe88bf',
    VERSION: '6'
  }
};

// Sign up, and authentication should always hit the same place.
const ENV_AUTH_API_SETTINGS = {
  PRODUCTION: {
    JP: {
      API_BASE_URL: 'https://jp-api.getmoneytree.com'
    },
    AU: {
      API_BASE_URL: 'https://au-api.getmoneytree.com'
    },
    myAccount: 'https://myaccount.getmoneytree.com'
  },
  STAGING: {
    JP: {
      API_BASE_URL: 'https://jp-api-staging.getmoneytree.com'
    },
    AU: {
      API_BASE_URL: 'https://au-api-staging.getmoneytree.com'
    },
    myAccount: 'https://myaccount-staging.getmoneytree.com'
  },
  DEVELOPMENT: {
    JP: {
      API_BASE_URL: 'https://jp-api-staging.getmoneytree.com'
    },
    AU: {
      API_BASE_URL: 'https://au-api-staging.getmoneytree.com'
    },
    myAccount: 'https://myaccount-staging.getmoneytree.com'
  }
};

const ENV_CLOUD_SAFE_SETTINGS = {
  PRODUCTION: {
    rotateImageFunction: 'MtGuestUploads-production-imageRotate'
  },
  STAGING: {
    rotateImageFunction: 'MtGuestUploads-staging-imageRotate'
  },
  DEVELOPMENT: {
    rotateImageFunction: 'MtGuestUploads-staging-imageRotate'
  }
};

const APP_SETTINGS = ENV_APP_SETTINGS[process.env.REACT_APP_STAGE_ENVIRONMENT];
const AUTH_API_SETTINGS = ENV_AUTH_API_SETTINGS[process.env.REACT_APP_STAGE_ENVIRONMENT];
const CLOUD_SAFE_SETTINGS = ENV_CLOUD_SAFE_SETTINGS[process.env.REACT_APP_STAGE_ENVIRONMENT];

export {
  APP_SETTINGS,
  AUTH_API_SETTINGS,
  CLOUD_SAFE_SETTINGS
};
